import React, { FC, forwardRef, PropsWithChildren } from 'react';
import { TabProps } from './types/tab-props';
import { TabBase } from './tab-base';

export const Tab = forwardRef((props, ref) => <TabBase {...props} ref={ref} />) as FC<PropsWithChildren<TabProps>>;
